<template>
<v-layout v-resize="onResize" column style="padding-top:56px">
  <v-data-table flat v-model="selected" :headers="headers" :items="resources"
    class="elevation-2" :loading="isLoading" :total-items="totalResources"
    :rows-per-page-items="[50, 100]" :pagination.sync="pagination" select-all
    item-key="id" disable-initial-sort
    :hide-headers="isMobile" :class="{mobile: isMobile}"
  >
    <template slot="headers" slot-scope="props">
      <tr>
        <th>
          <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate"
            primary hide-details @click.stop="toggleAll" >
          </v-checkbox>
        </th>
        <th v-for="header in props.headers" :key="header.text" hide-details
          class="text-capitalize" >
          {{ header.text }}
        </th>
      </tr>
    </template>

    <template slot="items" slot-scope="props">
      <tr v-if="!isMobile" :active="props.selected" @click="props.selected = !props.selected">
      <td>
        <v-checkbox :input-value="props.selected" primary ></v-checkbox>
      </td>
      <td class="text-xs-center">{{ dateFormatted(props.item.due_on) }}</td>
      <td class="text-xs-center">{{ daysToDeposit(props.item.due_on) }}</td>
      <td class="text-xs-center">{{ props.item.payment_id }}</td>
      <td class="text-xs-center">{{ $n(props.item.amount, 'currency') }}</td>
      <td class="text-xs-center">{{ $n(props.item.amount_with_anticipation_fee, 'currency') }}</td>
      <td class="text-xs-center">
        <v-chip :color="setChipColor(props.item.status)"
          class="text-capitalize" small text-color="white">
            {{ $t(`status.${props.item.status}`) }}
        </v-chip>
      </td>
      <td class="text-xs-center">
        {{ props.item.installment }}
      </td>
      <td class="text-xs-center">{{ $d(new Date(props.item.updated_at), 'dateAndTime') }}</td>
      </tr>

      <tr v-else :active="props.selected" @click="props.selected = !props.selected">

         <td>
          <ul class="flex-content">
            <li class="flex-item"><v-checkbox :input-value="props.selected" primary ></v-checkbox></li>
            <li class="flex-item" data-label="Data para Depósito">{{ dateFormatted(props.item.due_on) }}</li>
            <li class="flex-item" data-label="Dias para Depósito">{{  daysToDeposit(props.item.due_on) }}</li>
            <li class="flex-item" data-label="Referente ao Pagamento">{{ props.item.payment_id }}</li>
            <li class="flex-item" data-label="Valor">{{ $n(props.item.amount, 'currency') }}</li>
            <li class="flex-item" data-label="Valor Antecipável">{{ $n(props.item.amount_with_anticipation_fee, 'currency') }}</li>
            <li class="flex-item" data-label="Status">
              <v-chip :color="setChipColor(props.item.status)"
                class="text-capitalize" small text-color="white">
                  {{ $t(`status.${props.item.status}`) }}
              </v-chip>
            </li>
            <li class="flex-item" data-label="Parcela">{{ props.item.installment }}</li>
            <li class="flex-item" data-label="Última Atualização">{{ $d(new Date(props.item.updated_at), 'dateAndTime') }}</li>
          </ul>
        </td>
      </tr>
    </template>
  </v-data-table>
  </v-layout>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  mounted() {
    this.$store.dispatch('user/getAnticipationsAvailable', this.filters);
  },
  computed: {
    ...mapGetters({
      resources: 'user/anticipationsAvailable',
      totalResources: 'user/anticipationsAvailableCount',
      currentTax: 'user/currentTax',
      filters: 'user/anticipationsFilter',
      selectedAnticipations: 'user/selectedAnticipations',
      selectedAnticipationsLimit: 'user/selectedAnticipationsLimit',
      currentPage: 'user/anticipationsAvailablePage',
      isLoading: 'user/loading',
    }),
    pages() {
      return 0;
    },
  },
  watch: {
    selected: function selected(selected) {
      let value = 0;
      selected.forEach((deposit) => {
        value += parseFloat(deposit.amount_with_anticipation_fee);
      });
      this.updateSelectedAnticipationsAmount(value);
      this.updateSelectedAnticipations(selected);
    },
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.page, oldPagination.page)) {
        this.updateSelectedAnticipationsPage(newPagination.page);
        this.$store.dispatch('user/getAnticipationsAvailable', this.filters);
      }
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.updateSelectedAnticipationsLimit(newPagination.rowsPerPage);
        this.$store.dispatch('user/getAnticipationsAvailable', this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setSelectAnticipations: 'user/setSelectAnticipations',
      updateSelectedAnticipationsAmount: 'user/updateSelectedAnticipationsAmount',
      updateSelectedAnticipationsLimit: 'user/updateAnticipationsAvailableLimit',
      updateSelectedAnticipationsPage: 'user/updateAnticipationsAvailablePage',
      updateSelectedAnticipations: 'user/updateSelectedAnticipations',
    }),
    dateFormatted(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    toggleAll() {
      if (this.selected.length !== 0) {
        this.selected = [];
      } else {
        this.selected = this.resources.slice();
        this.setSelectAnticipations(this.selected);
      }
    },
    daysToDeposit(date) {
      const now = moment();
      const depositDate = moment(date);
      return depositDate.diff(now, 'days');
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  data() {
    return {
      items: [],
      selected: [],
      count: 0,
      pagination: {},
      isMobile: false,
      headers: [
        { text: 'Data para depósito', value: 'efetuado em' },
        { text: 'Dias para depósito', value: 'value' },
        { text: 'Referente ao Pagamento', value: 'rates' },
        { text: 'Valor', value: 'toReceive' },
        { text: 'Valor Antecipável', value: 'depositIn' },
        { text: 'Status', value: 'payment' },
        { text: 'Parcela', value: 'installment' },
        { text: 'Ultima Atualização', value: 'cardBrand' },
      ],
    };
  },
};
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid #636366;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f5f5f5;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
</style>
